import React, { useEffect, useState } from 'react'
import Header from '../layouts/Header';
import CategoryBreadCrumbs from '../components/categoryBreadCrumbs.jsx';
import { Link, Typography } from '@mui/material';
import ProductDetails from '../components/ProductDetails.jsx';
import Designers from '../../User/components/Designers';
import Aboutus from '../../User/components/Aboutus';
import Downloadapp from '../../User/components/Download_app';
import Footer from '../../User/layouts/Footer';
import about_image from '../assets/icons/about-image.svg'
import desiner_icon from '../assets/icons/desiner.svg'
import WhatsApp from "../../User/components/WhatsApp";
import { useParams, useSearchParams } from 'react-router-dom';
import instance from '../../Utils/api.js';




const DesignerData = [
  {
    image: desiner_icon,
    name: "Designer name",
    description: "Access hundreds of designs, choose your fabrics, and customize your outfit—all from the comfort of your home."
  },
  {
    image: desiner_icon,
    name: "Designer name",
    description: "Access hundreds of designs, choose your fabrics, and customize your outfit—all from the comfort of your home."
  },
  {
    image: desiner_icon,
    name: "Designer name",
    description: "Access hundreds of designs, choose your fabrics, and customize your outfit—all from the comfort of your home."
  },
  {
    image: desiner_icon,
    name: "Designer name",
    description: "Access hundreds of designs, choose your fabrics, and customize your outfit—all from the comfort of your home."
  },
  {
    image: desiner_icon,
    name: "Designer name",
    description: "Access hundreds of designs, choose your fabrics, and customize your outfit—all from the comfort of your home."
  },
  {
    image: desiner_icon,
    name: "Designer name",
    description: "Access hundreds of designs, choose your fabrics, and customize your outfit—all from the comfort of your home."
  },
]



const Product = () => {
  const { id } = useParams();
  const [design, setDesign] = useState();
  const [reviews, setReviews] = useState([]);
  const [searchparams] = useSearchParams();
  let Category = searchparams.get("Category");
  let CategoryId = searchparams.get("CategoryId");
  let subCategory = searchparams.get("subCategory");
  let subCategoryId = searchparams.get("subCategoryId");
  let design_type = searchparams.get("design_type");
  let design_type_id = searchparams.get("design_type_id");

  const getReviews = async () => {
    try {
      const response = await instance.get('Review/Allreviews')
      setReviews(response.data.reviews)
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    getReviews()
  }, [])

  const getDesign = async (id) => {
    try {
      const response = await instance.get(`/Catalogue/getDesignById?_id=${id}`);
      setDesign(response.data.data);
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    id && getDesign(id);
  }, [id])

  const breadcrumbs = [
    <Link underline="hover" key="catalogue" color="inherit" href="/Categories">
      Catalogue
    </Link>,

  ];

  if (Category && Category != "undefined") {
    breadcrumbs.push(
      <Link
        underline="hover"
        key="category"
        color="inherit"
        href={`/Categories?CategoryId=${CategoryId}&Category=${Category}`}
      >
        {Category}
      </Link>
    );
  }
  if (subCategory && subCategory != "undefined") {
    breadcrumbs.push(
      <Link
        underline="hover"
        key="sub-category"
        color="inherit"
        href={`/Categories?CategoryId=${CategoryId}&Category=${Category}&id=${subCategoryId}&name=${subCategory}`}
      >
        {subCategory}
      </Link>
    );
  }
  if (design_type) {
    breadcrumbs.push(
      <Link
        underline="hover"
        key="design-type"
        color="inherit"
        href={`/Categories?CategoryId=${CategoryId}&Category=${Category}&id=${subCategoryId}&name=${subCategory}&design_type_name=${design_type_id}&design_type=${design_type}`}
      >
        {design_type}
      </Link>
    );
  }
  breadcrumbs.push(
    <Typography variant="subtitle1" key="design-name">
      {design?.name}
    </Typography>
  );

  return (
    <React.Fragment>
      <React.Fragment>
        <Header />
      </React.Fragment>
      <React.Fragment>
        <CategoryBreadCrumbs breadcrumbs={breadcrumbs} />
      </React.Fragment>
      <React.Fragment>
        <ProductDetails data={design} />
      </React.Fragment>
      {/* <React.Fragment>
        <Designers data={DesignerData} />
      </React.Fragment> */}
      <React.Fragment>
        <Aboutus data={reviews} />
      </React.Fragment>
      <React.Fragment>
        <Downloadapp />
      </React.Fragment>
      <React.Fragment>
        <Footer />
      </React.Fragment>
      <WhatsApp />
    </React.Fragment>
  )
}

export default Product